// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import { getSites, updateSite, addSite, addStemID, createStem, initializeStripe } from './Api';
import { showLoader, INITIALIZE_STRIPE } from './actions';
export const LOAD_SITES = 'DASHBOARD_LOAD';

export const SAVE_SITEDATA = 'SAVE_SITEDATA';
export const UDPATE_SITE = 'UDPATE_SITE';
export const ADD_STEM_ID = 'ADD_STEM_ID';
export const CREATE_STEM = 'CREATE_STEM'
export const SHOW_ADD_STEM_ERROR = 'SHOW_ADD_STEM_ERROR';
export const SET_STEM_NAME = 'SET_STEM_NAME';
export const SET_STEM_LOCATION = 'SET_STEM_LOCATION';
export const HIDE_TOAST = 'HIDE_TOAST';

export function loadSites() {
  return function (dispatch) {
    initializeStripe().then(response => {
        dispatch({
            type: INITIALIZE_STRIPE,
            result: response
        });
        getSites()
        .then(response => {
          dispatch({ type: SAVE_SITEDATA, result: response.data });
            // console.log('sites::', response)
        })
        .catch(error => {
            // console.log('error::', error)
        });
    });
  };
}

export function updateSiteAction(siteId, data) {
  return function (dispatch) {
    updateSite(siteId, data)
      .then(response => {
        dispatch(loadSites());
      })
      .catch(error => {
          // console.log('error::', error)
      });
  };
}

export function addSiteAction(data) {
  return function (dispatch) {
    addSite(data)
      .then(response => {
        dispatch(loadSites());
      })
      .catch(error => {
          // console.log('error::', error)
      });
  };
}

export function showAddStemError (data) {
  return (dispatch => {
    dispatch({ type: SHOW_ADD_STEM_ERROR, result: data });
  });
}

export function addStemIDAction(data) {
  return function (dispatch) {
    if(data  && !data.showStemAddForm){
      dispatch({ type: ADD_STEM_ID, result: data.data });
    }
    else {
      addStemID(data.stemID)
      .then(response => {
        if(response && response.data && response.data.error){
          dispatch(showAddStemError(response.data));
        }
        else {
          dispatch({ type: ADD_STEM_ID, result: response });
        }
      })
      .catch(error => {
          // console.log('error::', error)
      });
    }
  }

}

export function setStemName (value) {
  return (dispatch => {
    dispatch({ type: SET_STEM_NAME, result: value });
  });
}

export function setStemLocation (value) {
  return (dispatch => {
    dispatch({ type: SET_STEM_LOCATION, result: value });
  });
}

export function createStemAction(stemObj) {
  return function (dispatch) {
    createStem(stemObj)
      .then(response => {
        if(response && response.duplicateStemError){
          dispatch({ type: SHOW_ADD_STEM_ERROR, result: response });
        }
        else {
          dispatch({ type: CREATE_STEM, result: response });
        }
      })
      .catch(error => {
          // console.log('error::', error)
      });
  }

}

export function hideToast(){
  return (dispatch => {
    dispatch({type: HIDE_TOAST, result: false})
  });
}



// WEBPACK FOOTER //
// ./src/js/actions/dashboard.js